import AdministrationView from './administration-view'

export default function AdministrationContainer() {
  return <AdministrationView />
}
